import request from '@/router/axios'
import env from '@/config/env'
import globalVariable from '@/config/globalVariable'

const { TIME } = globalVariable

/**
 *  获取供应商列表
 */
export const getMerchantList = () => {
  return request({
    url: env.ferryUrl + '/flightManage/queryMerchantList',
    method: 'GET',
    timeout: TIME
  })
}

/**
 *  获取老系统线路列表
 */
export const getLineList = () => {
  return request({
    url: env.ferryUrl + '/lineConfig/lineList',
    method: 'GET',
    timeout: TIME
  })
}

/**
 *  查询供应商相关的司机和车辆信息
 */
export const queryMerchantDriverAndCarInfo = (data) => {
  return request({
    url: env.ferryUrl + '/c-order/queryMerchantDriverAndCarInfo',
    method: 'POST',
    timeout: TIME,
    data
  })
}

/**
 * 财务统计（分页）
 */
export const queryOldFinanceStatisticPage = (data) => {
  return request({
    url: env.ferryUrl + '/old-finance-statistic/page',
    method: 'POST',
    timeout: TIME,
    data
  })
}

/**
 * 财务统计（汇总）
 */
export const queryOldFinanceStatisticSum = (data) => {
  return request({
    url: env.ferryUrl + '/old-finance-statistic/sum',
    method: 'POST',
    timeout: TIME,
    data
  })
}

/**
 * 老系统财务统计同步
 */
export const updateOldFinanceStatistic = (data) => {
  return request({
    url: env.ferryUrl + '/old-finance-statistic/sync',
    method: 'POST',
    timeout: TIME,
    data
  })
}
